export default ({ request }) => ({
  /**
   * 获取行程列表
   * @param params
   * @returns {*}
   * @constructor
   */
   RECRUIT_TRIP_LIST (params = {}) {
    // 接口请求
    return request({
      url: '/trip/list',
      method: 'GET',
      params
    })
  },
  /**
   * 根据id获取行程信息
   * @param params
   * @returns {*}
   * @constructor
   */
   RECRUIT_TRIP_Info (id, params = {}) {
    // 接口请求
    return request({
      url: `/trip/${id}`,
      method: 'GET',
      params
    })
  }
})

